import { css } from "@emotion/react"
import { above } from "@mkt/ui/styles/Breakpoints"
import { colors } from "iq-blueberry"

export const containerHidden = css`
  max-height: 0px;
`

export const container = css`
  display: flex;
  justify-content: flex-start;
  background-color: ${colors['blueberry-0']};
  margin: 32px 0 0;
  overflow: hidden;
  max-height: 250px;
  transition: max-height 0.5s ease;
  

  ${above["m"]} {
    display: none;
  }

  .iq-btn {
    padding: 5px 10px;
    font-family: "Open Sans",sans-serif;
    font-size: 16px;
    font-weight: 700;
  }
`

export const modalContainer = css`
  ${above["m"]} {
    display: none;
  }
`

export const modalContainerHidden = css`
  opacity: 0;
  visibility: hidden;
`

export const modal = css`
  justify-content: flex-end;
  flex-direction: row-reverse;
  margin: 0 16px 0;
  border-radius: 8px;
  overflow: hidden;
`

export const image = css`
  display: flex;
  justify-content: center;

  ${above["m"]} {
    display: block;
  }
`
export const figure = css`
  display: flex;
  justify-content: center;
  width: 140px;

  img {
    width: auto;
    height: 100%;
  }
`
export const figureModal = css`
  justify-content: flex-end;
  width: 150px;
`

export const data = css`
  padding: 24px 16px;
`
export const title = css`
  font-size: 20px;
  line-height: 28px;
  color: ${colors['blueberry-60']};
  margin-bottom: 8px;
`

export const subtitle = css`
  font-family: "Open Sans",sans-serif;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 14px;
`
